/* eslint-disable */
import * as React from "react";

import { useParameter, ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";
import { BusinessUnitControl } from "../controls/BusinessUnitControl";

import { useSubscription } from "./useSubscription";

export default function () {
  const [business] = useParameter<number>("@business-units");
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <BusinessUnitControl />
        <CommoditiesControl key={business || undefined} />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-net-trade" />
        </ReportGrid>
      </div>
    </>
  );
}
